export default function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(
            (registrations: ServiceWorkerRegistration[]) => {
                for (let registration of registrations) {  
                    registration.unregister();
                }
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/unregisterServiceWorker.ts